import React from "react";
import { connect } from "react-redux";

import { Button, FontIcon } from "react-md";

import { setActiveForm } from "../../actions/appActions";

import Translate from "../../Atollon/Translation";

import {canAddAtollonInstance} from "../../utils";
import {DebugElement} from "../../Atollon/debug";
import {TouchPageHeader} from "../../AtollonTheme/ReactElements";

const Header = ( state ) => {

    let { setActiveForm, role } = state;

  return (
      <TouchPageHeader
        debugText={"components/organization/Header.js"}
        title={Translate('MujAtollon-title','Můj Atollon')}
        buttons={(
            <div>
                {
                    canAddAtollonInstance(role) ?
                        <Button
                            raised
                            className="btn btn-primary touchButton-1"
                            label="Přidat existující atollon"
                            onClick={() => setActiveForm("organizationAddExistingForm")}
                        >
                            <FontIcon className="color-white">album</FontIcon>
                        </Button>
                        : ''
                }
                  <Button
                    raised
                    className="btn btn-primary touchButton-1"
                    label="Nový Atollon"
                    onClick={() => setActiveForm("organizationFoundForm")}
                  >
                    <FontIcon className="color-white">album</FontIcon>
                  </Button>
            </div>
        )}
      />
  );
};

export default connect(({ app: { role }}) => ({role}), { setActiveForm })(Header);



// WEBPACK FOOTER //
// ./src/components/organizations/Header.js